import config from '@/config';

/**
 * Single registry for options and affordances that exist only for manual testing.
 *
 * Everything exported here is already gated by `config.enableTestFeatures`, so call sites can
 * spread it unconditionally without repeating the environment check. Add new test-only entries
 * here instead of inline in components, so they can all be traced and switched off from one place.
 */

/** Values that are only offered while test features are on. */
const TEST_ONLY_VALUES: string[] = ['max'];

/** Widest available date range, for environments where recent calls do not exist. */
export const TEST_DATE_RANGE_OPTIONS: { value: 'max'; label: string }[] = config.enableTestFeatures
    ? [{ value: 'max', label: 'Max days (Test)' }]
    : [];

/**
 * True when a value picked while the switch was on is no longer offered.
 *
 * A selection like "Max days (Test)" outlives the switch in localStorage, so anything restoring a
 * stored selection must check this and fall back to its default.
 */
export const isDisabledTestValue = (value: unknown): boolean =>
    !config.enableTestFeatures && typeof value === 'string' && TEST_ONLY_VALUES.includes(value);
